import React, { ReactNode, useMemo, ReactElement } from "react";
type Props = {
  condition: boolean;
  Then: ReactNode;
  Else: ReactNode;
  deps?: unknown[];
};
const IFThen = ({
  condition,
  Then,
  Else,
  deps = []
}: Props): ReactElement => {
  const element = useMemo(() => condition ? Then : Else, [condition, deps]);
  return <>{element}</>;
};
export default IFThen;